export default {
  head: [
    {
      name: "NHP Home",
      path: "/",
    },
    {
      name: "GLOF Home",
      path: "/webgis-glacials",
      active: true,
    },

    // {
    //     name:"Glaciers Geo Portal",
    //     path:"/map-glaciers"
    // },

    {
      name: "Objective",
      path: "/webgis-glacials/proj-obj",
    },
  /*  {
      name:'Download Products',
      path:'/nhp-data-download'
    }*/
    // {
    //     name:"Technical Proposal",
    //     path:"/webgis-glacials/tech-prop"

    // },
    // {
    //     name:"Project Team",
    //     path:"/webgis-glacials/proj-team"

    // },
    // {
    //     name:"Financial Proposal",
    //     path:"/webgis-glacials/fin-prop"

    // }
  ],

  breadCrumbs: [
    {
      name: "menu 1",
      path: "/",
    },
    {
      name: "menu 2",
      path: "/",
    },
    {
      name: "menu 3",
      path: "/",
    },
  ],

  mapSideBar: [
    {
      id: 1,
      name: "Snow Cover",
      icon: "stroopwafel",
      hasdefault: true,
      children: [
        {
          id: 1,
          name: "Daily Snow Cover",
          icon: "stroopwafel",
          dateReq: true,
          sliderReq: true,
          ismap: true,
          default: true,
          graphstatus: false,
          information: "Daily Snow cover Area ",
        },
        {
          id: 2,
          name: "Snow Cover Fraction",
          icon: "stroopwafel",
          sliderReq: true,
          ismap: true,
          graphstatus: true,
          information:
            "Snow Cover fraction products are fortnightly generating",
        },
      ],
    },
    {
      id: 2,
      name: "Spatial Snowmelt",
      icon: "stroopwafel",

      children: [
        {
          id: 1,
          name: "Forecast",
          icon: "stroopwafel",
          dateReq: true,
          ismap: true,
          forecast: true,
          sliderReq: false,
          graphstatus: false,
          // "children":[
          //     {
          //     "id":1,
          //     "name":'08-05-2019',
          //     "ismap":true,
          //     "forecast":true
          //     },
          //     {
          //         "id":2,
          //         "name":'09-05-2019',
          //         "ismap":true,
          //         "forecast":true
          //     },
          //     {
          //         "id":3,
          //         "name":'10-05-2019',
          //         "ismap":true,
          //         "forecast":true
          //         }
          // ]
        },

        {
          id: 1,
          name: "Actual",
          icon: "stroopwafel",
          dateReq: true,
          ismap: true,
        },
      ],
    },

    {
      id: 3,
      name: "Base Layers",
      icon: "stroopwafel",
      hasdefault: true,
      children: [
        {
          id: 1,
          name: "DEM",
          icon: "stroopwafel",
        },

        {
          id: 2,
          name: "Satellite Imagery",
          icon: "stroopwafel",
        },
        {
          id: 3,
          name: "River Network",
          icon: "stroopwafel",
        },
        {
          id: 4,
          name: "Administrative",
          icon: "stroopwafel",
        },
        {
          id: 5,
          name: "Infrastructure",
          icon: "stroopwafel",
        },
        {
          id: 5,
          name: "LULC",
          icon: "stroopwafel",
        },
        // {

        // }
      ],
    },
    // {
    //     "id": 3,
    //         "name": 'Analysis',
    //         "icon":"stroopwafel",
    //         "children": [
    //             {
    //                 "id": 1,
    //                 "name": 'Basin',
    //                 "icon":"stroopwafel",

    //             },

    //             {
    //                 "id": 2,
    //                 "name": 'SubBasin',
    //                 "icon":"stroopwafel",

    //             }
    //         ]
    // }
  ],
};
